module.exports = __webpack_public_path__ + "img/staff-steve-tassone.bafe30f7.png";